import React, {Fragment} from "react";
import MusiciansList from "./MusiciansList";

export default function InstrumentsList({category, staff, musiciansList, musicians, dispatch}) {

    const changeMusicianHandler = (value, instrument, position) => {
        const dataset = {
            value: {...value, position: position},
            instrument: instrument,
        }
        dispatch({type: "SET_MUSICIAN", dataset});
    }

    return (<>
        {category.instruments.map((instr, index) => {
            
            if (staff[instr] === 0) return null
            let number_participants = 0;

            if (musicians && musicians[instr]) {
                number_participants = musicians[instr].length
            }
            const count_instr = number_participants <= staff[instr] ? staff[instr] : number_participants

            return (
                <Fragment key={index}>
                    <div className='col-sm-6 col-md-4'>
                        <p style={{fontWeight: 'bold'}}>
                            {instr} ({number_participants} / {staff[instr]})
                        </p>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            <MusiciansList
                                instrument={instr}
                                countInstr={count_instr}
                                musiciansList={musiciansList[instr]}
                                musicians={musicians}
                                changeMusicianHandler={changeMusicianHandler}
                                numer_participants={number_participants}
                                number_staff={staff[instr]}
                            />
                        </div>
                    </div>
                </Fragment>
                )
        })}
    </>)
}

